import { useSelector } from 'react-redux';

import { usePageName } from '@/productDiscovery/Listings/hooks/usePageName';
import { selectCategoryIds } from '@/productDiscovery/Listings/pages/Category/selectors/categoryIds';
import { useMassLandingCategoryId } from '@/productDiscovery/Listings/pages/MassLanding/selectors/massLanding';

export const useCategoryIds = () => {
  const pageName = usePageName();
  const categoryIds: string = useSelector(selectCategoryIds);
  const massLandingId: string = useMassLandingCategoryId();

  switch (pageName) {
    case 'category': {
      return categoryIds;
    }

    case 'massLanding': {
      return massLandingId;
    }

    default:
      return '';
  }
};
